/* eslint-disable no-unused-vars*/
import React, {Component, createElement} from 'react';
import fetch from 'node-fetch';

class WithApiData extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
        };
    }

    componentDidMount() {
        this.fetchApiData();
    }

    parseApiUrl = () => {
        const {
            endpoint,
            location: {search},
            match: {params},
        } = this.props;

        let apiUrl = endpoint;

        Object.keys(params).forEach((param) => {
            apiUrl = endpoint.replace(`:${param}`, params[param]);
        });

        if (search) {
            apiUrl = apiUrl.concat(search);
        }

        return apiUrl;
    };

    fetchApiData = () => {
        const url = this.parseApiUrl();

        fetch(url).then(async (response) => {
            const data = await response.json();
            this.setState({data});
        });
    };

    render() {
        const {component, ...rest} = this.props;
        const {data} = this.state;

        if (!data) {
            return null;
        }

        return createElement(component, {...rest, data});
    }
}

export default WithApiData;
